import {Button, Checkbox, DatePicker, Form, Input, Modal, Select, Tooltip} from "antd";
import moment from "moment";
import {useEffect, useState} from "react";
import {postLoa, putLoa} from "../../api/loaApi";
import sorters from "../../util/sorters";
import {LoaConfirmationModal} from "./LoaConfirmationModal";
import {PREFERRED_DATE_FORMAT} from "../../util/time";

const LoaModal = ({
                    isEditMode,
                    open,
                    onCancel,
                    record,
                    load,
                    employees,
                    resourceTypes,
                    leaveTypes,
                    employeeResourceTypes,
                    mapLeaveResourceTypes
                  }) => {
  const [form] = Form.useForm();
  // const user = useUser();
  // const [isIndefinite, setIsIndefinite] = useState(false);
  const [showLeaveTooltip, setShowLeaveTooltip] = useState(false);
  const [showResourceTooltip, setShowResourceTooltip] = useState(false);
  const [resourceTypeID, setResourceTypeID] = useState(0);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [confirmationData, setConfirmationData] = useState({
    employeeName: '',
    currentResourceType: '',
    leaveType: '',
    postResourceType: '',
    startDate: '',
    endDate: ''
  });
  const [filteredLeaveTypes, setFilteredLeaveTypes] = useState([]);
  const [displayWarning, setDisplayWarning] = useState(false);

  useEffect(() => {
    if (isEditMode && record) {
      // if (record.LeaveEndDate === null) {
      //   setIsIndefinite(true);
      // }
      form.setFieldsValue({
        Name: record.Employee.FullName,
        Email: record.Employee.Email,
        ResourceType: record.ResourceType.Name,
        PostResourceType: record.PostResourceType.ID,
        LeaveType: record.LeaveType.Name,
        LeaveStartDate: record.LeaveStartDate ? moment(record.LeaveStartDate).utc() : null,
        LeaveEndDate: record.LeaveEndDate ? moment(record.LeaveEndDate).utc() : null,
        TotalLeaveHours: record.TotalLeaveHours || 0,
        AutoScheduleTime: record.AutoScheduleTime,
        IndefiniteEnd: record.LeaveEndDate === null
      });
    } else {
      form.resetFields();
      form.setFieldsValue({AutoScheduleTime: true});
    }
  }, [isEditMode, record, form]);

  const cancel = () => {
    form.resetFields();
    onCancel();
  };

  const onComplete = async (completedForm) => {
    if (isEditMode) {
      const loa = {
        ID: record.ID,
        LeaveStartDate: completedForm.LeaveStartDate,
        // LeaveEndDate: isIndefinite ? null : completedForm.LeaveEndDate,
        // TotalLeaveHours: isIndefinite ? null : completedForm.TotalLeaveHours,
        LeaveEndDate: completedForm.LeaveEndDate,
        TotalLeaveHours: completedForm.TotalLeaveHours,
        AutoScheduleTime: completedForm.AutoScheduleTime,
      }
      await putLoa(loa);
    } else {
      const loa = {
        EmployeeId: completedForm.Name,
        ResourceTypeId: resourceTypeID,
        PostResourceTypeId: completedForm.PostResourceType,
        LeaveTypeId: completedForm.LeaveType,
        LeaveStartDate: completedForm.LeaveStartDate,
        // LeaveEndDate: isIndefinite ? null : completedForm.LeaveEndDate,
        // TotalLeaveHours: isIndefinite ? null : completedForm.TotalLeaveHours,
        LeaveEndDate: completedForm.LeaveEndDate,
        TotalLeaveHours: completedForm.TotalLeaveHours,
        // AutoScheduleTime: isIndefinite ? false : completedForm.AutoScheduleTime,
        AutoScheduleTime: completedForm.AutoScheduleTime,
      }
      await postLoa(loa);
    }

    await load();
  };

  const submit = async () => {
    const cForm = form.getFieldsValue();


    if (!isEditMode) {
      const employeeName = employees.find(employee => employee.ID === cForm.Name).fullName
      const currentResourceType = cForm.ResourceType;
      const leaveType = leaveTypes.find(leaveType => leaveType.ID === cForm.LeaveType).Name;
      const postResourceType = resourceTypes.find(type => type.ID === cForm.PostResourceType)?.Name;
      const startDate = cForm.LeaveStartDate.format(PREFERRED_DATE_FORMAT);
      //const endDate = form.getFieldValue('LeaveEndDate') ? form.getFieldValue('LeaveEndDate').format(PREFERRED_DATE_FORMAT) : '';
      const endDate =  cForm.LeaveEndDate.format(PREFERRED_DATE_FORMAT);
      const totalLeaveHours = form.getFieldValue('TotalLeaveHours') || '';
      setConfirmationData({
        employeeName,
        currentResourceType,
        leaveType,
        postResourceType,
        startDate,
        endDate,
        totalLeaveHours
      });
      setConfirmationVisible(true)
    } else {
      onComplete(cForm);
      form.resetFields();
      onCancel();
    }
  };

  const calculateTotalLeaveHours = (startDate, endDate) => {
    let totalHours = 0;
    let currentDate = moment(startDate);

    while (currentDate.isSameOrBefore(endDate, 'day')) {
      // Day 0 = Sunday, Day 6 = Saturday
      if (currentDate.day() !== 0 && currentDate.day() !== 6) {
        totalHours += 8;
      }
      currentDate.add(1, 'day');
    }
    return totalHours;
  };

  const onDateChange = () => {
    const {LeaveStartDate, LeaveEndDate} = form.getFieldsValue();
    if (LeaveStartDate && LeaveEndDate) {
      const totalLeaveHours = calculateTotalLeaveHours(LeaveStartDate, LeaveEndDate);
      form.setFieldsValue({TotalLeaveHours: totalLeaveHours});
    }
  };

  const validateStartDate = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }
    const endDate = form.getFieldValue('LeaveEndDate');
    if (!endDate) {
      return Promise.resolve();
    }
    if (value.isBefore(endDate)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Leave Start Date must be before Leave End Date'));
  }

  const validateEndDate = (_, value) => {
    const currentDate = moment();
    if (!value) {
      return Promise.resolve();
    }
    if (value.isBefore(currentDate)) {
      return Promise.reject(new Error('Leave End Date must be after today'));
    }
    const startDate = form.getFieldValue('LeaveStartDate');
    if (!startDate) {
      return Promise.resolve();
    }
    if (value.isAfter(startDate)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Leave End Date must be after Leave Start Date'));
  };

  const updateFilteredLeaveList = (resourceTypeID) => {
    if (resourceTypeID) {
      const selectedEmployeeLeaveTypeList = mapLeaveResourceTypes
        .filter(leaveResourceType => leaveResourceType.ResourceTypeId === resourceTypeID)
        .map(type => type.LeaveTypeId)
      setFilteredLeaveTypes(leaveTypes.filter(leaveType => selectedEmployeeLeaveTypeList.includes(leaveType.ID)));

      if (!selectedEmployeeLeaveTypeList.length) {
        setDisplayWarning(true)
        form.setFieldsValue({LeaveType: ''});
      }
    }
  }

  const onEmployeeChange = (value) => {
    const selectedEmployee = employees.find(employee => employee.ID === value);
    setFilteredLeaveTypes(leaveTypes);
    setDisplayWarning(false);

    if (selectedEmployee) {
      const selectedEmployeeResourceTypeIdList = employeeResourceTypes
        .find(resourceType => selectedEmployee.ID === resourceType?.EmployeeId);
      const selectedEmployeeResourceType = resourceTypes
        .find(resourceType => resourceType.ID === selectedEmployeeResourceTypeIdList?.ResourceTypeId);
      setResourceTypeID(selectedEmployeeResourceType.ID)
      updateFilteredLeaveList(selectedEmployeeResourceType.ID)

      form.setFieldsValue({
        Email: selectedEmployee.email,
        ResourceType: selectedEmployeeResourceType.Name || '',
        PostResourceType: selectedEmployeeResourceType.ID || ''
      });
    } else {
      form.setFieldsValue({Email: ''});
    }
  };

  return (
    <>
      <Form name={'LoaForm'} form={form} onFinish={submit} labelCol={{span: 7}} onValuesChange={onDateChange}>
        <Modal
          title={`${isEditMode ? 'Edit' : 'Create'} Leave of Absence`}
          open={open}
          width={725}
          onCancel={cancel}
          footer={[
            <Button key="cancel" onClick={cancel}>Cancel</Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>
              Save
            </Button>
          ]}
        >
          <Form.Item key={'Name'} label={'Employee Name'} name={'Name'}
                     rules={[{required: true, message: '\'Name\' is required'}]}>
            <Select
              showSearch
              placeholder="Select Employee Name"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(a, b) =>
                (sorters.string(a.label, b.label))
              }
              options={employees.map(e => ({
                value: e.ID,
                label: e.fullName
              }))}
              onChange={onEmployeeChange}
              disabled={isEditMode}
            />
          </Form.Item>
          {displayWarning && <div style={{
            marginLeft: 200,
            marginTop: -15,
            marginBottom: 5,
            color: "#ff4d4f"
          }}>{'Employee Resource Type not found in Map Leave To Resource Type'}</div>}
          <Form.Item key={'Email'} label={'Email'} name={'Email'}>
            <Input disabled={true}/>
          </Form.Item>
          <Form.Item key={'ResourceType'} label={'Resource Type'} name={'ResourceType'}>
            <Input disabled={true}/>
          </Form.Item>
          <Tooltip
            open={showLeaveTooltip}
            title="If you would like to change Leave Type, please cancel the leave and recreate it."
            placement="bottom"
          >
            <Form.Item key={'LeaveType'} label={'Leave Type'} name={'LeaveType'}
                       rules={[{required: true, message: '\'Leave Type\' is required'}]}>
              <Select
                showSearch
                placeholder="Select Employee Leave Type"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.label.toLocaleLowerCase().indexOf(input.toLocaleLowerCase()) >= 0}
                filterSort={(a, b) =>
                  (sorters.string(a.label, b.label))
                }
                options={filteredLeaveTypes.map(r => ({
                  value: r.ID,
                  label: r.Name
                }))}
                disabled={!filteredLeaveTypes.length}
                onMouseEnter={isEditMode ? () => setShowLeaveTooltip(true) : null}
                onMouseLeave={() => setShowLeaveTooltip(false)}
              />
            </Form.Item>
          </Tooltip>
          <Tooltip
            open={showResourceTooltip}
            title="If you would like to change Post Resource Type, please cancel the leave and recreate it."
            placement="bottom"
          >
            <Form.Item key={'PostResourceType'} label={'Post Resource Type'} name={'PostResourceType'}
                       rules={[{required: true, message: '\'Post Resource Type\' is required'}]}>
              <Select
                showSearch
                placeholder="Select Post Employee Resource Type"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.label.toLocaleLowerCase().indexOf(input.toLocaleLowerCase()) >= 0}
                filterSort={(a, b) =>
                  (sorters.string(a.label, b.label))
                }
                options={resourceTypes.map(r => ({
                  value: r.ID,
                  label: r.Name
                }))}
                disabled={isEditMode}
                onMouseEnter={isEditMode ? () => setShowResourceTooltip(true) : null}
                onMouseLeave={() => setShowResourceTooltip(false)}
              />
            </Form.Item>
          </Tooltip>
          <Form.Item
            key={'LeaveStartDate'}
            label={'Leave Start Date'}
            name={'LeaveStartDate'}
            rules={[{required: true, message: '\'Leave Start Date\' is required'}, {validator: validateStartDate}]}
          >
            <DatePicker format={PREFERRED_DATE_FORMAT}/>
          </Form.Item>
          {/*<Form.Item key={'IndefiniteEnd'} label={'Unknown End Date'} name={'IndefiniteEnd'} valuePropName="checked">*/}
          {/*  <Checkbox onChange={() => setIsIndefinite(!isIndefinite)} />*/}
          {/*</Form.Item>*/}
          {/*{isIndefinite ? null : (*/}
          {(
            <>
              <Form.Item
                key={'LeaveEndDate'}
                label={'Leave End Date'}
                name={'LeaveEndDate'}
                rules={[{required: true, message: '\'Leave End Date\' is required'}, {validator: validateEndDate}]}
              >
                <DatePicker format={PREFERRED_DATE_FORMAT}/>
              </Form.Item>
              <Form.Item key={'TotalLeaveHours'} label={'Total Leave Hours'} name={'TotalLeaveHours'}>
                <Input disabled={true} style={{width: '75px'}}/>
              </Form.Item>
              <Form.Item key={'AutoScheduleTime'} label={'Automatically Schedule Time'} name={'AutoScheduleTime'}
                         valuePropName="checked">
                <Checkbox/>
              </Form.Item>
            </>)}
        </Modal>
      </Form>
      <LoaConfirmationModal
        visible={confirmationVisible}
        onCancel={() => setConfirmationVisible(false)}
        onConfirm={() => {
          onComplete(form.getFieldsValue());
          form.resetFields();
          onCancel();
          setConfirmationVisible(false);
        }}
        employeeName={confirmationData.employeeName}
        currentResourceType={confirmationData.currentResourceType}
        leaveType={confirmationData.leaveType}
        postResourceType={confirmationData.postResourceType}
        startDate={confirmationData.startDate}
        endDate={confirmationData.endDate}
        totalLeaveHours={confirmationData.totalLeaveHours}
      />
    </>
  )
}

export default LoaModal; 